import script from "./PartialPharmacyBillReturnTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PartialPharmacyBillReturnTable.vue?vue&type=script&setup=true&lang=js"

import "./PartialPharmacyBillReturnTable.vue?vue&type=style&index=0&id=4babeb28&lang=css"

const __exports__ = script;

export default __exports__